import CustomButton, { SecondaryButton } from 'components/CustomButton'
import TableItemLoader from 'components/TableItemLoader'
import CardBody from 'components/card/CardBody'
import CustomCard from 'components/card/CustomCard'
import CustomCardHeader from 'components/card/CustomCardHeader'
import FormLabel from 'components/form/FormLabel'
import TextArea from 'components/form/TextArea'
import ToggleSwitch from 'components/toggleSwitch/ToggleSwitch'
import { isNotEmpty } from 'helpers/stringHelper'
import { useCallback, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { updateRemoteConfig } from 'redux/slices/remoteConfigSlice'
import { remoteConfigType } from '../RemoteConfig'

const NoticeSection = ({
  notice,
  setNotice,
  setConfigType,
  setShowConfirmationModal,
  updateNoticeAction,
  fetchRemoteConfigAction,
}) => {
  const [isEditingNotice, setIsEditingNotice] = useState(false)

  const dispatch = useDispatch()
  const { loading, error, remoteConfig } = useSelector(
    (state) => state.remoteConfig,
  )

  const isNoticeValid = () => {
    return isNotEmpty(notice?.title_en) && isNotEmpty(notice?.title_np)
  }

  const activateDeactivateNotice = () => {
    if (remoteConfig?.config?.notice.active) {
      setConfigType(remoteConfigType.notice)
      setShowConfirmationModal(true)
    } else {
      updateNoticeAction()
    }
  }

  const saveNotice = useCallback(() => {
    const payload = {
      configType: 'Notice',
      configPayload: {
        config: {
          notice: {
            ...notice,
            active: notice.active,
          },
        },
      },
    }
    dispatch(updateRemoteConfig(payload))
    setIsEditingNotice(false)
  }, [notice])

  const handleCancel = () => {
    setIsEditingNotice(false)
    setNotice(remoteConfig.config.notice)
  }

  return (
    <div className="flex-1">
      <CustomCard>
        <CustomCardHeader contentPosition="none">
          <div className="w-full flex items-center justify-between">
            <h2 className="text-white text-2xl">Notice</h2>
            {!isEditingNotice ? (
              <ToggleSwitch
                isChecked={remoteConfig?.config?.notice?.active ?? false}
                onChange={activateDeactivateNotice}
              />
            ) : (
              <></>
            )}
          </div>
        </CustomCardHeader>
        {loading || error.length > 0 ? (
          <TableItemLoader
            loading={loading}
            error={error}
            retry={fetchRemoteConfigAction}
            isCircular={true}
          />
        ) : (
          <div>
            <CardBody>
              {isEditingNotice ? (
                <div>
                  <TextArea
                    label="English"
                    placeholder="Write notice in English..."
                    defaultValue={remoteConfig?.config?.notice.title_en}
                    onChange={(value) => {
                      setNotice({ ...notice, title_en: value })
                    }}
                  />
                  <TextArea
                    label="नेपाली"
                    placeholder="नेपालीमा सूचना लेख्नुहोस्..."
                    defaultValue={remoteConfig?.config?.notice.title_np}
                    onChange={(value) => {
                      setNotice({ ...notice, title_np: value })
                    }}
                  />
                  <div className="flex justify-end space-x-4">
                    <SecondaryButton onClick={handleCancel}>
                      Cancel
                    </SecondaryButton>
                    <CustomButton
                      disabled={!isNoticeValid()}
                      onClick={saveNotice}
                    >
                      Save
                    </CustomButton>
                  </div>
                </div>
              ) : (
                <div>
                  <FormLabel label="English" />
                  <p className="mb-4">
                    {remoteConfig?.config?.notice.title_en}
                  </p>
                  <FormLabel label="Nepali" />
                  <p className="mb-4">
                    {remoteConfig?.config?.notice.title_np}
                  </p>
                  <div className="flex justify-end items-center mt-8">
                    <CustomButton onClick={() => setIsEditingNotice(true)}>
                      Edit
                    </CustomButton>
                  </div>
                </div>
              )}
            </CardBody>
          </div>
        )}
      </CustomCard>
    </div>
  )
}

export default NoticeSection
